// extracted by mini-css-extract-plugin
module.exports = {"container":"Disclaimer_container__3s_Zp","title":"Disclaimer_title__10Bok","sectionTitle":"Disclaimer_sectionTitle__2RNVa","paragraph":"Disclaimer_paragraph__5XXcR"};